import {Component,
        EventEmitter,
        ContentChildren,
        ViewChildren,
        ElementRef,
        ViewContainerRef,
        OnInit,
        OnChanges,
        SimpleChanges,
        AfterContentInit,
        Optional,
        Host,
        Input,
        QueryList,
        Injectable } from '@angular/core';

import {
    HammerGestureConfig,
    HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';

@Injectable()
export class DotHammerConfig extends HammerGestureConfig  {
    buildHammer(element: HTMLElement) {
        let mc = new Hammer(element, {
        touchAction: "pan-y"
        });
        return mc;
    }
}

@Component({
    selector: 'dot-navigation-page',
    template: `
        <ng-content></ng-content>
    `,
    styles:[`
        :host{
            width: 100%;
            height: 100%;
            display: inline-table;
        }
    `]
})
export class DotNavigationPage {
    constructor() {}
}

@Component({
    selector: 'dot-navigation',
    template: `
        <div class="dot-navigation" (swipeleft)="swipe($event.type)" (swiperight)="swipe($event.type)">
            <ng-content></ng-content>
        </div>
        <div class="dot-navigation-scroll">
            <span (click)="nextPage(p)" *ngFor="let p of numPages" class="dots" [ngClass]="{'active-dot':page==p}"></span>
        </div>
        `,
    styles: [`
        :host{
            width: 100%;
        }
        .dot-navigation{
            width: 100%;
            white-space: nowrap;
            overflow-x: hidden;
        }
        .dot-navigation-scroll{
            display: flex;
            justify-content: center;
        }
        .dots{
            background: transparent;
            display: block;
            height: 12px;
            width: 12px;
            border-radius: 14px;
            border: 2px solid #5e5e5e;
            margin: 2px;
            box-sizing: border-box;
            cursor: pointer;
        }
        .dots.active-dot{
            background:#5e5e5e;
        }
    `]
})
export class DotNavigationComponent implements AfterContentInit {
    public numPages:number[] = [];
    private page = 0;
    private SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
    @ContentChildren(DotNavigationPage) pages:QueryList<DotNavigationPage> ;

    constructor(private elementRef: ElementRef){}

    ngAfterContentInit(){
        for(let i = 0; i < this.pages.length; i++){
            this.numPages.push(i);
        }
    }

    nextPage(nextPage:number){
        let jump = nextPage - this.page; 
        let child = this.elementRef.nativeElement.querySelector(".dot-navigation");
        child.scrollLeft += jump*child.offsetWidth;
        this.page = nextPage;
    }
    
    swipe(action:string = this.SWIPE_ACTION.RIGHT) {
        let nextPage = 0;
        if(action == this.SWIPE_ACTION.RIGHT){
            nextPage = this.page - 1;
            nextPage = (nextPage<0)?(this.numPages.length-1):nextPage;
        }else{
            nextPage = this.page + 1;
            nextPage = (nextPage>this.numPages.length-1)?0:nextPage;
        }
        this.nextPage(nextPage);
    }
}